<template>
  <div>
    <div><vue-file-toolbar-menu :content="menu" /></div>
  </div>
</template>

<script>
import VueFileToolbarMenu from 'vue-file-toolbar-menu'
import BarEmojiWidget from './BarEmojiWidget.vue';
import {isEmpty} from 'lodash';
import {Nodes} from './Nodes';

export default {

  props: {

    activeTools: {
      type: Array,
      default: []
    },

    nodes: {
      type: Array,
      default: function () {
        return Object.keys(Nodes);
      }
    },

    widgets: {
      type: String,
      default: function () {
        return 'undo,redo,|,headers,|,bold,italic,|,color,|,quote,|,bulleted,numbered,|,link,|,emoji,|,clear';
      }
    }
  },

  mounted () {

    //build activeNodes

    //console.log('the active nodes', this.activeNodes)
  },

  components: {
    VueFileToolbarMenu,
    BarEmojiWidget,
  },

  watch: {

    activeTools: function(activeNodeList) {
      //console.log('node list', activeNodeList)
      this.setActiveNodes(activeNodeList);
    },
  },

  data () {

    let buildActiveNodes = function () {
      let nodes = Object.assign({}, Nodes);

      for (let prop in nodes) {
        nodes[prop].active = false;
      }

      return nodes;
    };

    return {
      happy: false,

      activeNodes: buildActiveNodes()
    }
  },

  methods: {

    setActiveNodes (activeNodeList) {
      this.clearActiveNodes();

      console.log('nodeslst', activeNodeList)
      console.log('the active list', this.activeNodes);

      activeNodeList.forEach(nodeName => {
        // console.log('hte nodenm', nodeName)
        this.activeNodes[nodeName].active = true;
      })

      // console.log('the active list', this.activeNodes);
    },

    clearActiveNodes () {
      Object.keys(this.activeNodes).forEach(nodeName => {
        this.activeNodes[nodeName].active = false;
      })
    }
  },

  computed: {

    /**
     * Build the toolbar menu
     *
     * @return Object widget
     */
    menu () {
      const widgets = this.widgets.split(',');
      let menu = [];
      let $vm = this;

      widgets.forEach(name => {
        if (name == '|') name = 'separator';

        let widget = $vm[name];

        if (isEmpty(widget)) {
          return console.error(`${widget} is not a defined widget`);
        }

        menu.push(widget);
      })

      return menu;
    },

    /**
     * Add headers and paragraph styling
     *
     * @return Object
     */
    headers () {
      return {
        text: "Paragraph",
        menu: [
          { text: "Paragraph", click: () => this.$emit('command', { action: 'setParagraph' }) },
          { text: "Heading 1", click: () => this.$emit('command', { action: 'toggleHeading', params: [{level: 1}] }) },
          { text: "Heading 2", click: () => this.$emit('command', { action: 'toggleHeading', params: [{level: 2}] }) },
          { text: "Heading 3", click: () => this.$emit('command', { action: 'toggleHeading', params: [{level: 3}] }) },
          { text: "Heading 4", click: () => this.$emit('command', { action: 'toggleHeading', params: [{level: 4}] }) },
          { text: "Heading 5", click: () => this.$emit('command', { action: 'toggleHeading', params: [{level: 5}] }) },
          { text: "Heading 6", click: () => this.$emit('command', { action: 'toggleHeading', params: [{level: 6}] }) },
        ]
      }
    },

    /**
     * separator for toolbar menu
     *
     * @return Object
     */
     separator () {
       return { is: 'separator' };
     },

    /**
     * undo lastest change
     *
     * @return Object
     */
    undo () {
      return {
        icon: "undo",
        click: () => this.$emit('command', { action: 'undo' })
      }
    },

    /**
     * redo previous change
     *
     * @return Object
     */
    redo () {
      return {
        icon: "redo",
        click: () => this.$emit('command', { action: 'redo' })
      }
    },

    /**
     * Bold text
     *
     * @return Object
     */
    bold () {
      return {
        icon: "format_bold",
        active: this.activeNodes.bold.active,
        click: () => this.$emit('command', { action: 'toggleBold' }),
      }
    },

    /**
     * Add italic styling to text
     *
     * @return Object
     */
    italic () {
      return {
        icon: "format_italic",
        active: this.activeNodes.italic.active,
        click: () => this.$emit('command', { action: 'toggleItalic' })
      }
    },

    /**
     * color component
     *
     * @return Object
     */
    color () {
      return {
        is: "button-color",
        type: "compact",
        menu_class: "align-center",
        stay_open: false,
        color: '#ccc',
        update_color: (color) => {
          this.$emit('command', { action: 'setColor', params: [color.hex] })
        }
      }
    },

    /**
     * insert a quote
     *
     * @return Object
     */
    quote () {
      return {
        icon: "format_quote",
        active: this.activeNodes.blockquote.active,
        click: () => this.$emit('command', { action: 'toggleBlockquote' })
      }
    },

    /**
     * insert a bulleted list
     *
     * @return Object
     */
    bulleted () {
      return {
        icon: "format_list_bulleted",
        active: this.activeNodes.bulletList.active,
        click: () => this.$emit('command', { action: 'toggleBulletList' })
      }
    },

    /**
     * insert a numbrered list
     *
     * @return Object
     */
    numbered () {
      return {
        icon: "format_list_numbered",
        active: this.activeNodes.orderedList.active,
        click: () => this.$emit('command', { action: 'toggleOrderedList' })
      }
    },

    /**
     * create a link
     *
     * @return Object
     */
    link () {
      return {
        icon: "insert_link",
        active: this.activeNodes.link.active,
        click: () => this.$emit('command', { action: 'setLink' })
      }
    },

    /**
     * emoji widget component ( add emojis )
     *
     * @return Object
     */
    emoji () {
      return {
        is: BarEmojiWidget,
        icon: "insert_emoticon",
        click: (emoji) => this.$emit('command', {action: 'insertContent', params: [emoji]})
      }
    },

    /**
     * Clear all formatting from node
     *
     * @return Object
     */
    clear () {
      return {
        icon: "format_clear",
        click: () => {
          this.$emit('command', { action: 'clearNodes' })
          this.$emit('command', { action: 'unsetAllMarks' })
        }
      }
    }
  }
}
</script>
